import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SalaryDetails from './SalaryDetails';
import SalaryForm from './SalaryForm';
import { motion } from 'framer-motion';

const DEVELOPING_COUNTRIES = ['ne', 'cm'];

const FormHome = ({ country, setCountry }) => {
  const { t } = useTranslation();
  const [serverResponse, setServerResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [calculationType, setCalculationType] = useState('net');

  const COUNTRIES = [
    { code: 'sn', name: t('countries.sn'), flag: '🇸🇳', description: t('countries.sn_description') },
    { code: 'ci', name: t('countries.ci'), flag: '🇨🇮', description: t('countries.ci_description') },
    { code: 'ne', name: t('countries.ne'), flag: '🇳🇪', description: t('countries.developing_description') },
    { code: 'cm', name: t('countries.cm'), flag: '🇨🇲', description: t('countries.developing_description') },
  ];

  return (
    <div className='p-8 md:p-12'>
      <div className='pb-8'>
        <motion.h2
          className='text-2xl md:text-3xl font-bold text-gray-800'
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {t('simulatorForm.heading')}
        </motion.h2>
        <motion.p
          className='text-gray-600 mt-2'
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          {t('simulatorForm.subtitle')}
        </motion.p>
      </div>

      {/* Le sélecteur de pays est déplacé dans Simulateur.js */}

      {/* Si le pays est en développement, affiche seulement le message */}
      {DEVELOPING_COUNTRIES.includes(country) ? (
        <motion.div
          className="max-w-xl mx-auto bg-yellow-50 border border-yellow-200 rounded-xl p-8 text-center text-yellow-700 mt-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="flex flex-col items-center gap-3">
            <span className="text-4xl mb-2">
              {COUNTRIES.find(c => c.code === country)?.flag}
            </span>
            <h3 className="text-xl font-bold mb-2">
              {t('simulatorForm.developing_heading', { country: COUNTRIES.find(c => c.code === country)?.name })}
            </h3>
            <p>
              {t('simulatorForm.developing_body')}
            </p>
          </div>
        </motion.div>
      ) : (
        // Sinon, affiche le formulaire et le résultat
        <div className="flex flex-col lg:flex-row gap-8">
          <motion.div 
            className="card w-full lg:w-[60%] bg-white"
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <SalaryForm
              setServerResponse={setServerResponse}
              setLoading={setLoading}
              calculationType={calculationType}
              setCalculationType={setCalculationType}
              country={country}
            />
          </motion.div>
          <motion.div 
            className='w-full lg:w-[46%]'
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            {loading ? (
              <div className="flex flex-col items-center justify-center h-full min-h-[300px]">
                <div className="w-16 h-16 border-4 border-t-orange-500 border-gray-200 rounded-full animate-spin"></div>
                <p className="mt-4 text-gray-600">{t('simulatorForm.loading')}</p>
              </div>
            ) : (
              <SalaryDetails serverResponse={serverResponse} calculationType={calculationType} loading={loading} country={country} />
            )}
          </motion.div>
        </div>
      )}
    </div>
  );
};

export default FormHome;